import React, { FC } from 'react';
import Typography from '@material-ui/core/Typography';
import {
  Box,
  BoxProps,
  createStyles,
  makeStyles,
  Popover,
  Theme,
} from '@material-ui/core';
import Divider from '@material-ui/core/Divider';

interface IAgencies extends BoxProps {
  agencies: string[];
}

const Agencies: FC<IAgencies> = (props) => {
  const { agencies, ...others } = props;
  const classes = usePopStyles();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
  ) => {
    if (agencies.length > 1) setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <Box {...others}>
      <Typography
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}>
        {agencies?.join(', ')}
      </Typography>
      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus>
        <Typography variant={'button'}>Ses autres agences</Typography>
        <Divider className={classes.divider} />
        {agencies
          .filter((agency, index) => index > 0)
          .map((agency) => (
            <Typography>{agency}</Typography>
          ))}
      </Popover>
    </Box>
  );
};

const usePopStyles = makeStyles((theme: Theme) =>
  createStyles({
    popover: {
      pointerEvents: 'none',
    },
    paper: {
      padding: theme.spacing(1),
    },
    divider: {
      marginBottom: 5,
    },
  }),
);

export default Agencies;
